import ApiService from "./api.service";
import { encryptStorage } from "./encrypt.service"; 
import router from "../router/main-router";
import { visualizationClient } from "./public.service";
import { VISUALIZATION_ROUTE_NAME } from "../helpers/ow.route.helper";
import { getRetryNotBefore } from "../helpers/retry.after.helper";

class CustomCss extends ApiService {
    constructor() {
        super();
        // pobranie stylów okna wizualizacji w toku albo ponowienie zaplanowane po 429 - najwyżej jedno
        this.visualizationCssRequest = null;
    }

    isLoggedIn() {
        const token = encryptStorage.getItem("token");
        return (token !== undefined && token !== null && token !== "");
    }

    injectCss() {

        router.isReady()
                .then(async () => {
                    let route = router.currentRoute._value
                    let response = null;
                    switch (route.name) {
                        case "PublicSession": response = await this.getNewestStylesByToken(route.name, route.params.code); break;
                        case "Overlay": response = await this.getNewestStylesByToken(route.name, route.params.code); break;
                        case "Visualization": this.injectVisualizationCss(route.params.councilId, route.params.code); break;
                        case "PublicSessionInfo": break;
                        default: 
                            if (this.isLoggedIn()) {
                                let response = await this.getNewestStyles();

                                if (response.status !== 200)
                                    return;

                                this.createInlineStyles(response.data);
                            }
                            break;
                    }

                    if (response !== null && response.data !== undefined && response.status !== undefined && response.status === 200) {
                        this.createInlineStyles(response.data);
                    }
                });
    }

    createInlineStyles(customStyles){
        if(customStyles === undefined || customStyles === null || customStyles === ""){
            return;
        }

        let styles = document.createElement("style")
        styles.setAttribute("type", "text/css")
        document.head.appendChild(styles);
        styles.textContent = customStyles;
    }

    /**
     * Style okna wizualizacji dla jednostki i adresu z trasy, przez klienta bez globalnych interceptorów
     * (ekran bez obsługi). Serwer limituje je per jednostka: po 429 dotychczasowe style zostają, a pobranie
     * jest ponawiane raz, po terminie z Retry-After. Ponowne wywołanie dla tego samego linku w trakcie pobrania
     * albo oczekiwania nic nie robi; inny link zastępuje poprzedni.
     */
    injectVisualizationCss(councilId, code) {
        const pending = this.visualizationCssRequest;

        if (pending !== null && pending.code === code && pending.councilId === councilId) {
            return;
        }

        if (pending !== null) {
            clearTimeout(pending.timer);
        }

        const request = { councilId, code, timer: null };
        this.visualizationCssRequest = request;
        this.loadVisualizationCss(request);
    }

    async loadVisualizationCss(request) {
        try {
            const response = await visualizationClient.get(`api/management/custom-css/newest/styles/visualization/${encodeURIComponent(request.councilId)}/${encodeURIComponent(request.code)}`);

            if (this.visualizationCssRequest !== request) {
                return;
            }

            this.visualizationCssRequest = null;

            if (response.status === 200) {
                this.createInlineStyles(response.data);
            }
        }
        catch (error) {
            if (this.visualizationCssRequest !== request) {
                return;
            }

            if (error.response !== undefined && error.response.status === 429) {
                const delay = Math.max(0, getRetryNotBefore(error) - Date.now());
                request.timer = setTimeout(() => this.retryVisualizationCss(request), delay);
                return;
            }

            this.visualizationCssRequest = null;
            console.log(error);
        }
    }

    retryVisualizationCss(request) {
        request.timer = null;

        if (this.visualizationCssRequest !== request) {
            return;
        }

        // okno opuszczone albo otwarte z innym linkiem - ponowienie nie ma już sensu
        const route = router.currentRoute.value;

        if (route.name !== VISUALIZATION_ROUTE_NAME || route.params.code !== request.code || route.params.councilId !== request.councilId) {
            this.visualizationCssRequest = null;
            return;
        }

        this.loadVisualizationCss(request);
    }

    getNewestStyles(){
        return this.get("api/management/custom-css/newest/styles")
    }

    getNewestStylesByToken(tokenType, token) {
        return this.get(`api/management/custom-css/newest/styles/by-token/${tokenType}/${token}`)
    }

    getNewest(){
        return this.get("api/management/custom-css/newest")
    }

    getById(id){
        return this.get(`api/management/custom-css/${id}`);
    }

    getAll(){
        return this.get(`api/management/custom-css`);
    }

    async create(data){
        let reponse = await this.post(`api/management/custom-css`, data);
        this.injectCss();
        return reponse
    }
}

export default new CustomCss();